import React, { useEffect } from 'react';

import { useAxios } from '../../../AxiosHandler';

import { useTranslate } from 'react-polyglot';
import { useParams } from 'react-router-dom';

import styles from './PuppyListings.module.scss';
import PublicTable from '../../Shared/PublicTable/PublicTable';
import Card from '../../Shared/Card/Card';
import { Form } from 'react-bootstrap';

function PuppyListings(props: PuppyListingsProps) {
    const t = useTranslate();
    const params = useParams();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [loading, setLoading] = React.useState(true);

    const [dogs, setDogs] = React.useState<any>([]);
    const [filteredDogs, setFilteredDogs] = React.useState<any>([]);

    const [publishTypeFilter, setPublishTypeFilter] = React.useState("both");
    /**
     * 
     * BIRTHDATE
     * PUPSBORN
     * FREETEXT
     * DAM_TITLE_PRIZE
     * SIRE_TITLE_PRIZE
     * INNAVL_AVKOM
     * INNAVL_AVKOM_8_GEN
     * RELATIONSHIP_INDEX
     * HD_INDEX
     * DWARF
     * GLAUKOM
     * M1_EBV_BAND
     * M2_EBV_BAND
     * M1_EBV_LOS
     * M3_EBV_LOS
     * M5_EBV_LOS
     * M9_EBV_LOS
     * 
     */

    const fieldBlacklist = [
        "BREED",
        "BIRTHDATE",
        "PUPSBORN",
        "FREETEXT",
        "DAM_TITLE_PRIZE",
        "SIRE_TITLE_PRIZE",
        "INNAVL_AVKOM",
        "INNAVL_AVKOM_8_GEN",
        "RELATIONSHIP_INDEX",
        "HD_INDEX",
        "DWARF",
        "GLAUKOM",
        "M1_EBV_BAND",
        "M2_EBV_BAND",
        "M1_EBV_LOS",
        "M3_EBV_LOS",
        "M5_EBV_LOS",
        "M9_EBV_LOS"
    ];


    function getPuppyListings() {
        setLoading(true);
        axios.single({
            method: 'get',
            url: "/api/dogs/puppylistings/" + params.breedid,
            responseType: 'json',
        }).then((res: any) => {
            setDogs(res.data);

            let tempDogs = res.data;
            if (publishTypeFilter != "both") {
                tempDogs = res.data.filter((dog: any) => {
                    return dog.PUBLISHED_PUBLIC == publishTypeFilter;
                });
            }

            // Remove blacklisted fields from each dog
            tempDogs = tempDogs.map((dog: any) => {
                let newDog: any = { ...dog };
                fieldBlacklist.forEach(field => {
                    delete newDog[field];
                });
                return newDog;
            });

            setFilteredDogs(tempDogs);
        }).catch((err: any) => {
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }

    function calculateAge(birthdate: string) {
        const birth = new Date(birthdate);
        const now = new Date();
        const diff = now.getTime() - birth.getTime();
        const age = new Date(diff);
        return Math.abs(age.getUTCFullYear() - 1970);
    }

    useEffect(() => {
        getPuppyListings();
    }, []);

    useEffect(() => {
        let tempDogs = dogs;
        if (publishTypeFilter != "both") {
            tempDogs = dogs.filter((dog: any) => {
                if (dog.PUBLISHED_PUBLIC == "1") return true;
                return dog.PUBLISHED_PUBLIC == publishTypeFilter;
            });
        }
    }, [publishTypeFilter]);
    
    return (
        <div className={styles.puppylistings}>
            <h1>{t('puppylistings.title')}</h1>
            {loading ? 
                <p>{t('puppylistings.loading')}</p>
            : null}
            {filteredDogs.length > 0 ?
                <div
                    className={styles.tablecontainer}
                >
                    <PublicTable
                        headers={[
                            ...Object.keys(filteredDogs[0]).map((key: string) => {
                                // Skip some columns
                                if (key == "PUBLISHED_PUBLIC") return null;

                                // Custom display for some columns
                                if (key == "DATE_BIRTH") {
                                    return {
                                        label: t("puppylistingsconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => calculateAge(data.DATE_BIRTH)
                                    };
                                }
                                if (key == "OWNER_NAME") {
                                    return {
                                        label: t("puppylistingsconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => data.OWNER_NAME == ", " ? "" : data.OWNER_NAME
                                    };
                                }
                                if (key == "SEX") {
                                    return {
                                        label: t("puppylistingsconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => t("puppylistings.filters.values." + data.SEX + "single")
                                    };
                                }
                                if (key == "STATUS") {
                                    return {
                                        label: t("puppylistingsconfig.publiccolumns.titles." + key),
                                        field: key,
                                        override: (data: any) => t("puppylistings.filters.values.statuses." + data.STATUS)
                                    };
                                }
                                const wrap = key === "DAM_TITLE_CLASS" || key === "SIRE_TITLE_CLASS";
                                return { label: t("puppylistingsconfig.publiccolumns.titles." + key), field: key, wrap };
                            }).filter((header: any) => header != null)
                        ]}
                        data={filteredDogs}
                    ></PublicTable>
                </div>
            : null}
            {filteredDogs.length == 0 && !loading ?
                <p>{t('puppylistings.noresults')}</p>
            : null}
        </div>
    );
}

class PuppyListingsProps {
    
}

export default PuppyListings;